<div class="marv_item"
    [class.full_height]="this.fullHeight"
    >
    <ng-content></ng-content>
</div>